import { render, staticRenderFns } from "./manyTypeCode.vue?vue&type=template&id=6f732b10&scoped=true&"
import script from "./manyTypeCode.vue?vue&type=script&lang=js&"
export * from "./manyTypeCode.vue?vue&type=script&lang=js&"
import style0 from "./manyTypeCode.vue?vue&type=style&index=0&id=6f732b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f732b10",
  null
  
)

export default component.exports